import fallbackBg from "@images/customer_banner_fallback.webp";
import styled from "styled-components";
import { useSpring, animated } from "@react-spring/web";

type CustomerBannerProps = {
  bannerSrc?: string;
  title: string;
  logoSrc?: string;
};

const BANNER_HEIGHT = 200;

let hasAnimated = false;

export const CustomerBanner = ({ bannerSrc = fallbackBg, title, logoSrc }: CustomerBannerProps) => {
  const springProps = useSpring({
    from: hasAnimated
      ? { opacity: 1, transform: "translateY(0px)", height: BANNER_HEIGHT }
      : { opacity: 0, transform: "translateY(-10px)", height: 0 },
    to: { opacity: 1, transform: "translateY(0px)", height: BANNER_HEIGHT },
    config: { tension: 180, friction: 20 },
    onRest: () => {
      hasAnimated = true;
    },
  });

  return (
    <animated.section
      style={{
        ...springProps,
        background: `url(${bannerSrc}) center center/cover`,
        overflow: "hidden",
      }}
      className="w-full relative 3xl:max-w-[var(--homeLayoutWidth)] 3xl:mx-auto">
      <img
        src={bannerSrc}
        alt="Banner background"
        className="h-full w-full absolute inset-0 object-cover"
      />
      <div className="absolute inset-0 h-full w-full bg-gradient-to-b from-transparent to-[#00000057] bg-opacity-10" />
      <div className="max-w-[var(--homeLayoutWidth)] w-full h-full mx-auto lg:pb-10 flex justify-center items-center lg:justify-start lg:items-end 3xl:justify-center">
        <div className="flex flex-col items-center gap-6 lg:flex-row lg:items-end">
          {logoSrc && (
            <div className="overflow-hidden rounded-md border-2 border-white bg-white drop-shadow-md">
              <img
                src={logoSrc}
                className="h-[5rem] w-[5rem] rounded-md object-cover"
              />
            </div>
          )}
          <ClampedHeading className="pb-2 text-white drop-shadow-[1px_1px_3px_rgba(0,0,0,0.5)] font-display font-medium">
            {title}
          </ClampedHeading>
        </div>
      </div>
    </animated.section>
  );
};

const ClampedHeading = styled("h1")`
  font-size: clamp(1rem, 10vw, 42px);
`;
